import { getComponentFromName } from '@folklore/utils';

import * as Components from '../../interactives/index';

interface InteractiveBlockProps {
    name?: string | null;
    [key: string]: unknown;
}

function InteractiveBlock({ name = null, ...otherProps }: InteractiveBlockProps) {
    const Component = getComponentFromName(Components, name, null);
    return Component !== null ? <Component {...otherProps} /> : null;
}

export default InteractiveBlock;
